const CategoryPage = () => import('@/application-pages/Category/CategoryPage');

function getPageProps(page) {
    const pageProps = window.__dyanmic_template_props__[page];

    if (!pageProps) {
        return {};
    }

    if (page === 'CategoryPage') {
        pageProps['use-review-as-home-page'] = true;
    }

    return pageProps;
}

function getHomePageRoute() {
    let route = {
        path: languagePath + '/',
        props: getPageProps('CategoryPage'),
        component: CategoryPage,
        name: 'home',
    };

    const host = window['__host__'];

    if (host['smart_consumer_tips_article_list']) {
        route['component'] = () =>
            import('@/application-pages/ArticleBasedLayout/ArticleBasedLayout');
        route['props'] = getPageProps('ArticleBasedLayout');
    }

    if (host['ranking_table'] && host['ranking_table'] === 'Review') {
        route['component'] = () => import('@/application-pages/Review/Review');
        route['props'] = {
            ...route['props'],
            ...getPageProps('ReviewPage'),
            useReviewAsHomePage: true,
        };
    }

    return route;
}

let routes = [];
const languagePath = '';

routes = routes.concat([
    {
        path: languagePath + '/faq',
        component: () =>
            import('@/application-pages/SecondaryPage/SecondaryPage.vue'),
        name: 'faq',
    },
    {
        path: languagePath + '/about-us',
        component: () =>
            import('@/application-pages/SecondaryPage/SecondaryPage.vue'),
        name: 'aboutus',
    },
    {
        path: languagePath + '/privacy',
        component: () =>
            import('@/application-pages/SecondaryPage/SecondaryPage.vue'),
        name: 'privacy',
    },
    {
        path: languagePath + '/imprint',
        component: () =>
            import('@/application-pages/SecondaryPage/SecondaryPage.vue'),
        name: 'imprint',
    },
    {
        path: languagePath + '/compliance',
        component: () =>
            import('@/application-pages/Compliance/CompliancePage.vue'),
        name: 'compliance',
        meta: {
            title: '18 U.S.C. § 2257 / § 2257A Record-Keeping Requirements Compliance Statement',
        },
    },
    {
        path: languagePath + '/report-content',
        component: () =>
            import('@/application-pages/ReportContent/ReportContent'),
        name: 'reportContent',
    },
    {
        path: languagePath + '/review/:id',
        component: () => import('@/application-pages/Review/Review'),
        name: 'review',
        props: getPageProps('ReviewPage'),
    },
    {
        path: languagePath + '/partner-review/:position',
        component: () => import('@/application-pages/Review/Review'),
        name: 'partner-review',
    },
    {
        path: languagePath + '/comparison',
        component: () => import('@/application-pages/Comparison/Comparison'),
        name: 'comparison',
        props: getPageProps('ComparisonPage'),
    },
    {
        path: languagePath + '/articles',
        component: () => import('@/application-pages/ArticleList/ArticleList'),
        name: 'articles',
        props: getPageProps('ArticleListPage'),
    },
    {
        path: languagePath + '/article/:id',
        component: () => import('@/application-pages/Article/Article'),
        name: 'article',
        props: getPageProps('ArticlePage'),
    },
    {
        path: languagePath + '/articles/:id',
        component: () => {
            return import(`@/application-pages/ArticleTopic/ArticleTopic`);
        },
        name: 'article-topic',
        props: getPageProps('ArticleTopic'),
    },
    {
        path: languagePath + '/games/:id',
        component: () => {
            return import(`@/application-pages/AdSenseGame/GamePage`);
        },
        name: 'adsense-game-page',
    },
    {
        path: languagePath + '/search/:term',
        component: () => {
            return import('@/application-pages/SearchPage/SearchPage');
        },
        name: 'search',
    },
    {
        path: languagePath + '/:category',
        props: getPageProps('CategoryPage'),
        component: CategoryPage,
        name: 'category',
    },
]);

routes.push(getHomePageRoute());
routes.push({
    path: '*',
    beforeEnter: (to, from, next) => {
        next(languagePath + '/');
    },
});

export default routes;
